module.exports = __webpack_public_path__ + "img/marketing.acdab62c.svg";